const ItemTypes = { CARD: "card", BOX: "box" };

export default ItemTypes;
